import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { data } from 'autoprefixer';
import { Link } from 'react-router-dom';
import About from './About';
function Projects() {
    const [projects, setProject] = useState([]);
    const getProjects = async () => {
        try {
            const { data } = await axios.get("https://hr-meheraj-portfolio.herokuapp.com/projects/");
            setProject(data);
            console.log(data)
        } catch (err) {
            console.log(err.message);
        }
    }
    useEffect(() => {
        getProjects();
    }, []);

    return (
        <>
            <h2 className="font-bold text-center text-xl md:text-2xl md:text-6xl uppercase mt-[40px] bg-clip-text text-transparent bg-gradient-to-r from-red-500 via-yellow-500 to-blue-500">Projects</h2>
            <img src='https://flevix.com/wp-content/uploads/2020/01/Preloader-image.svg' className='w-full h-[50px]' />
            {
                projects.length === 0 && <h2 className='text-xl text-center my-[50px]'>Project is Loading....</h2>
            }
            <div
                className='grid grid-cols-1  md:grid-cols-2 my-[50px] gap-y-[50px] gap-x-[25px]'>
                {
                    projects?.map((project) => {
                        return (
                            <Link to={`/projects/${project?._id}`}
                                className='bg-center card-border hover:scale-[1.03] transition-all bg-cover h-[380px]  relative rounded-md p-4 ' style={{ backgroundImage: `url(${project?.imgURL})` }} key={project?._id}>
                                <div className='absolute hover:border-[3px] hover:border-white top-0 left-0 bottom-0 right-0 rounded-md bg-[#112233ea] opacity-0 hover:opacity-100 cursor-pointer  flex justify-center items-center'>
                                    <Link to={`/projects/${project?._id}`} className='btn btn-secondary hover:btn-primary  gap-2'>View Details
                                        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 5l7 7-7 7M5 5l7 7-7 7"></path></svg>

                                    </Link>
                                </div>
                            </Link>
                        )
                    })
                }
            </div>
        </>
    )
}

export default Projects